/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export default {
  path: '/mytracker',
  name: 'mytracker',
  children: [
    {
      path: '/',
      name: 'mytracker-index',
      load: () => import(/* webpackChunkName: 'mytracker' */ './default'),
    },
    {
      path: '/kpis',
      name: 'mytracker-kpis',
      load: () => import(/* webpackChunkName: 'mytracker' */ './kpis'),
    },
    // {
    //   path: '/education',
    //   name: 'mytracker-education',
    //   load: () => import(/* webpackChunkName: 'mytracker' */ './education'),
    // },
    {
      path: '/detail/:pageKey',
      name: 'mytracker-detail',
      load: () => import(/* webpackChunkName: 'mytracker' */ './detail-view'),
    },
    {
      path: '/reports',
      name: 'mytracker-reports',
      load: () => import(/* webpackChunkName: 'mytracker' */ './reports'),
    },
    {
      path: '/saved',
      name: 'mytracker-saved',
      load: () => import(/* webpackChunkName: 'mytracker' */ './saved'),
    },
    {
      path: '/saved-edit',
      name: 'mytracker-saved-edit',
      load: () => import(/* webpackChunkName: 'mytracker' */ './saved-edit'),
    },
    {
      path: '/loyalty',
      name: 'mytracker-loyalty-dashboard',
      load: () =>
        import(/* webpackChunkName: 'mytracker' */ './loyalty/dashboard'),
    },
    // {
    //   path: '/map-view',
    //   name: 'mytracker-mapview',
    //   load: () => import(/* webpackChunkName: 'mytracker' */ './map-view'),
    // },
  ],
  action({ next, store, url }, { siteId }) {
    const state = store.getState();
    const modules =
      (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    const options =
      (((state.session || {}).USER_DATA || {}).group || {}).options || [];

    if (!modules.includes('mytracker')) {
      return {
        redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
          url || '',
        )}`,
      };
    }

    if (
      url.includes('mytracker/loyalty') &&
      !options.includes('user.mytracker.loyaltyDashboard')
    ) {
      return {
        redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
          url || '',
        )}`,
      };
    }
    return next();
  },
};



// WEBPACK FOOTER //
// ./src/routes/client/site/mytracker/index.js